export default "__VITE_ASSET__CG8q1YF1__"